export const onboardPartialAccountAction = 'onboard-partial';

export const errorState = {
  error: 'There was an error creating your account. Text us at (415) 214-8119.',
  errorVisible: true,
};
